import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminContacts = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CONTACTS.GET_ALL, { params });
    return response.data;
};
export const getAdminContactById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CONTACTS.GET_BY_ID(id));
    return response.data;
};
export const createContact = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.CONTACTS.CREATE, data);
    return response.data;
};
export const updateContact = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.CONTACTS.UPDATE(id), data);
    return response.data;
};
export const deleteContact = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.CONTACTS.DELETE(id));
    return response.data;
};

